import { ZAttrLabelsAttributes } from "../types/ZAttrLabelsData";

export const getAllLabelDataAttributes = (data?: ZAttrLabelsAttributes) => [
  ...(data?.own || []),
  ...(data?.external || []),
];
